'use client';
import { Button } from '@pickleballinc/ui/components/ui/button';
import clsx from 'clsx';
import { useSearchParams, useRouter } from 'next/navigation';

import { PodStats } from '@/utils/helpers';

interface PodTabsProps {
	pods: { name: string; uuid: string }[];
	activePodUuid: string;
	className?: string;
	matchupCountsByPod?: PodStats[];
}

export const PodTabs = ({ pods, activePodUuid, className = '', matchupCountsByPod }: PodTabsProps) => {
	const router = useRouter();
	const searchParams = useSearchParams();

	const handleTabClick = (uuid: string) => {
		const params = new URLSearchParams(searchParams.toString());
		params.set('podUuid', uuid);
		router.replace(`?${params.toString()}`, { scroll: false });
	};

	return (
		<div className={`flex gap-2 overflow-x-auto scrollbar-hide sm:gap-4 sm:justify-start ${className}`}>
			{pods.map((pod, index) => {
				const total = matchupCountsByPod ? matchupCountsByPod[index]?.total : 0;
				const completed = matchupCountsByPod ? matchupCountsByPod[index]?.numberOfCompleted : 0;
				const completedLabel = `(${completed} of ${total})`;
				return (
					<Button
						key={pod.uuid}
						type="button"
						onClick={() => handleTabClick(pod.uuid)}
						className={clsx(
							'!px-1 !py-0.5 sm:!px-4 sm:!py-2',
							'rounded-lg text-sm min-w-[112px] sm:text-base md:text-xl sm:flex-row sm:gap-2 flex flex-col items-center text-center gap-0.5',
							pod.uuid === activePodUuid
								? 'border border-solid bg-orange-50 border-orange-700 text-[#E04F16] font-semibold shadow-none outline-none hover:bg-orange-50 hover:text-[#E04F16]'
								: 'bg-white hover:bg-white border border-gray-400 text-gray-500 hover:text-gray-500 font-semibold hover:border-[#E04F16] transition-colors shadow-none outline-none'
						)}
						variant="outline"
					>
						<span className="leading-tight">
							{pod.name.charAt(0).toUpperCase() + pod.name.slice(1)} {completedLabel}
						</span>
					</Button>
				);
			})}
		</div>
	);
};
